import { Box, Divider, Grid, GridProps, Typography } from "@mui/material";
import { useLayoutEffect, useRef } from "react";
import { useAppNavDrawer } from "~/providers/app-nav-drawer";
import {
  CicdGradientIcon,
  ExportsIcon,
  SaasIcon,
  ThirdPartyDataIcon,
  TicketIcon,
  WifiGradientIcon,
  WorkstationIcon,
} from "~/icons";
import {
  ChatOutlined as ChatOutlinedIcon,
  CloudOutlined as CloudOutlinedIcon,
  DnsOutlined as DnsOutlinedIcon,
  SchemaOutlined as SchemaOutlinedIcon,
} from "@mui/icons-material";

const stripTitle = (title: string) => {
  return title.replace(/[^\w]/gi, "").toLowerCase();
};

interface AvailableIntegrationCardDividerProps extends GridProps {
  title: string;
}

export const AvailableIntegrationCardDivider = ({
  title,
  ...gridProps
}: AvailableIntegrationCardDividerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const icon = getDividerIcon(title);

  const { navbarHeight } = useAppNavDrawer();

  useLayoutEffect(() => {
    if (location.hash) {
      const formattedHash = location.hash.replace(/^#/, "");
      if (formattedHash === stripTitle(title)) {
        if (ref.current) {
          const y = ref.current.offsetTop - 20 - navbarHeight;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
    }
  }, []);

  return (
    <Grid container alignItems="center" mt={5} mb={3} {...gridProps}>
      <Grid sx={{ display: "flex", alignItems: "center" }}>
        {icon && <Box sx={{ mr: 2 }}>{icon}</Box>}
        <Box ref={ref} id={stripTitle(title)}>
          <Typography
            className="integration-cards-list-title"
            fontWeight="fontWeightBold"
            sx={{
              display: "inline-block",
              pr: 3,
              fontSize: { xs: 20, sm: 24 },
            }}
          >
            {title}
          </Typography>
        </Box>
      </Grid>
      <Grid size="grow">
        <Divider />
      </Grid>
    </Grid>
  );
};

const getDividerIcon = (title: string) => {
  switch (title.toLowerCase()) {
    case "security engineering":
      return <WorkstationIcon color="primary" sx={{ fontSize: 56 }} />;
    case "server & endpoint security":
      return <DnsOutlinedIcon color="primary" sx={{ fontSize: 56 }} />;
    case "saas":
      return <SaasIcon color="primary" sx={{ fontSize: 56 }} />;
    case "network security":
      return <WifiGradientIcon sx={{ fontSize: 56 }} />;
    case "cloud security":
      return <CloudOutlinedIcon color="primary" sx={{ fontSize: 56 }} />;
    case "supply chain":
      return <SchemaOutlinedIcon color="primary" sx={{ fontSize: 56 }} />;
    case "ticket systems":
      return <TicketIcon color="primary" sx={{ fontSize: 56 }} />;
    case "third-party data":
      return <ThirdPartyDataIcon color="primary" sx={{ fontSize: 56 }} />;
    case "chat ops":
      return <ChatOutlinedIcon color="primary" sx={{ fontSize: 56 }} />;
    case "ci/cd":
      return <CicdGradientIcon color="primary" sx={{ fontSize: 56 }} />;
    case "exports":
      return <ExportsIcon color="primary" sx={{ fontSize: 56 }} />;
    default:
      return null;
  }
};
